import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a7ab9b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "planname" }, "OTC Pro Monthly")
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "planprice" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-0a7ab9b2><div class=\"col\" data-v-0a7ab9b2><ul class=\"list-group list-group-flush plan-features\" data-v-0a7ab9b2><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Real-time Nasdaq, NYSE and AMEX</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Level 1 and Level 2 quotes</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Pre-market, Regular market and After-hours</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>All market scanners</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>News Stream with full real-time news</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Montage</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Charts</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Prints (Time Sales)</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Integrations with TDA and IB</li></ul></div></div>", 1)
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "planname" }, "OTC Pro Annual")
  ])
], -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "planprice" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-0a7ab9b2><div class=\"col\" data-v-0a7ab9b2><ul class=\"list-group list-group-flush\" data-v-0a7ab9b2><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Real-time Nasdaq, NYSE and AMEX</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Level 1 and Level 2 quotes</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Pre-market, Regular market and After-hours</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>All market scanners</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>News Stream with full real-time news</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Montage</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Charts</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Prints (Time Sales)</li><li class=\"list-group-item border-0\" data-v-0a7ab9b2>Integrations with TDA and IB</li></ul></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["row collapse", { show: _ctx.plan.code === 'otcpro' }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, "$" + _toDisplayString(_ctx.formatPrice("otcpro")) + " / month", 1)
          ])
        ]),
        _hoisted_6
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["row collapse", { show: _ctx.plan.code === 'otcpro_annual' }])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, "$" + _toDisplayString(_ctx.formatPrice("otcpro_annual")) + " / year", 1)
          ])
        ]),
        _hoisted_12
      ])
    ], 2)
  ], 64))
}